import { render, staticRenderFns } from "./AiAskResourceBlock.vue?vue&type=template&id=56ae98d0&scoped=true&"
import script from "./AiAskResourceBlock.vue?vue&type=script&lang=js&"
export * from "./AiAskResourceBlock.vue?vue&type=script&lang=js&"
import style0 from "./AiAskResourceBlock.vue?vue&type=style&index=0&id=56ae98d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ae98d0",
  null
  
)

export default component.exports